import { TESTIMONIAL_GET_LIST,TESTIMONIAL_GET_LIST_SUCCESS,TESTIMONIAL_GET_LIST_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios'
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchTestimonialAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}UserRate/GetUserRatingList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const testimonialdetails = yield axios(config).then(response => response.data.Data);
        
        // console.log(subscriberDetails,"============")
        yield put({ type: TESTIMONIAL_GET_LIST_SUCCESS, data: testimonialdetails });
    } catch (error) {
        yield put({ type: TESTIMONIAL_GET_LIST_ERROR, error });
    }
}


export function* watchTestimonial() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(TESTIMONIAL_GET_LIST, fetchTestimonialAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchTestimonial),
    ]);
}